import { getParentOrigin, isEmbeddedInIframe } from './parentTokenRelay';

// Inside the Phantom iframe, links opened in a new tab must use Phantom's origin
// (the embedding page) so the user lands in the new navigation shell.
export const getAppOrigin = (): string => {
  if (!isEmbeddedInIframe()) return window.location.origin;
  try {
    const parentOrigin = getParentOrigin();
    return parentOrigin === '*' ? window.location.origin : parentOrigin;
  } catch {
    return window.location.origin;
  }
};
